import * as React from 'react'
import cx from 'classnames'
import { observer } from 'mobx-react'
import { useInfiniteScroll } from 'hooks/infinite-scroll'
import ConversationViewModel from '../../ConversationViewModel'
import styles from './List.sass'
import MessageGroup from './MessageGroup'
import { Id } from 'types/definitions'
interface Props extends React.HTMLAttributes<HTMLDivElement> {
  vm: ConversationViewModel
}

export default observer(function List({ vm }: Props) {
  const containerRef = React.useRef(null)
  useInfiniteScroll(containerRef, vm.scroller)

  React.useEffect(() => {
    return () => vm.setEditingMessageId(Id.none)
  }, [])

  return (
    <div className={cx(styles.root)}>
      <div className={styles.scrollZone} ref={containerRef} />
      {vm.messageGroups.map((group) => {
        return (
          <MessageGroup
            key={Id.assert(group.messages[0].message.id)}
            group={group}
            onMarkAsRead={(m) => vm.markAsRead(m)}
            vm={vm}
          />
        )
      })}
    </div>
  )
})
